(function () {
  // Carry tracking params (utm_*, fbclid) from the landing URL onto every
  // add-to-cart link, so they survive into checkout / attribution.
  function appendTrackingParams() {
    var src;
    try {
      src = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    var keep = new URLSearchParams();
    ['fbclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      if (src.get(k)) keep.set(k, src.get(k));
    });
    if (![...keep.keys()].length) return;

    document.querySelectorAll('a.js-cta').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        keep.forEach(function (v, k) {
          if (!url.searchParams.has(k)) url.searchParams.set(k, v);
        });
        link.href = url.toString();
      } catch (e) {}
    });
  }

  // Fire an AddToCart pixel event (if Meta Pixel is present) on CTA click.
  function bindAddToCartPixel() {
    document.querySelectorAll('a.js-cta').forEach(function (link) {
      link.addEventListener('click', function () {
        if (typeof window.fbq !== 'function') return;
        try {
          window.fbq('track', 'AddToCart', {
            content_name: link.dataset.productName || '',
            content_ids: [link.dataset.variantId || ''],
            content_type: 'product',
            value: parseFloat(link.dataset.price || '0'),
            currency: 'USD'
          });
        } catch (e) {}
      });
    });
  }

  // Show the sticky mobile add-to-cart bar after the visitor scrolls past the hero.
  function bindStickyBar() {
    var bar = document.getElementById('lander-sticky-bar');
    if (!bar) return;
    var onScroll = function () {
      bar.classList.toggle('is-visible', window.scrollY > 700);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    appendTrackingParams();
    bindAddToCartPixel();
    bindStickyBar();
  });
})();
